import { LucideIcon } from 'lucide-react'
import { FC } from 'react'
import { AppsLink, AppsRoutes } from '@wellesley/router'

type LinkItemProps = {
  Icon?: LucideIcon
  title: string
  route?: AppsRoutes
  routeProps?: { [key: string]: string }
  onClick?: () => void
  'data-testid'?: string
}

export const LinkItem: FC<LinkItemProps> = ({
  Icon,
  title,
  route,
  routeProps,
  onClick,
  'data-testid': testId,
}) => {
  const content = (
    <>
      {Icon && <Icon size={20} color="var(--gray-900)" />}
      <span className="text-base font-medium text-gray-900">{title}</span>
    </>
  )

  if (route) {
    return (
      <AppsLink
        to={route}
        props={routeProps}
        onClick={onClick}
        data-testid={testId}
        className="m-xxs gap-xs p-xxs rounded-m flex cursor-pointer flex-row  hover:bg-gray-100"
      >
        {content}
      </AppsLink>
    )
  }

  return (
    <div
      className="m-xxs gap-xs p-xxs rounded-m flex cursor-pointer flex-row hover:bg-gray-100"
      data-testid={testId}
      onClick={onClick}
    >
      {content}
    </div>
  )
}
